import { HttpClient } from '../../httpClient'
import {
  OpalApiRequestBody,
  OpalApiRequestParams,
  OpalApiResponseDocument,
} from '../../schema'

type Params = OpalApiRequestParams<'CreateBlockDuplicationV3'>
type RequestBody = OpalApiRequestBody<'CreateBlockDuplicationV3'>
type Response = OpalApiResponseDocument<'CreateBlockDuplicationV3', 201>

export const duplicateBlock = ({
  params,
  requestBody,
}: {
  params: Params
  requestBody: RequestBody
}) => {
  const url = new URL(
    `/loupe/v3/blocks/${params.path.block_id}/duplicate`,
    window.location.origin
  )

  return HttpClient()
    .post<Response>(url.toString(), requestBody)
    .then((res) => res.data)
}
